/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import PropTypes from 'prop-types';
import StorefrontFilters from '../../records/StorefrontFilters';
import * as RequestKey from '../../constants/RequestKey';
import * as FilterKey from '../../constants/search/FilterKey';
import * as SortField from '../../constants/search/SortField';
import { isSucceeded, isUninitialized } from 'ecosystem-marketplace-core/utils/requestState';
import * as DetailsActions from '../../actions/DetailsActions';
import { getCategoryFilterUrl, getSuperCategoryFilterUrl } from '../../utils/urls';
import { getCategoryI18nKey, getSuperCategoryI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import { DetailMainSection as MainSection } from 'ecosystem-marketplace-core/components/layout/MainSection';
import MainSectionInner from 'ecosystem-marketplace-core/components/layout/MainSectionInner';
import MainSectionHeading from 'ecosystem-marketplace-core/components/layout/MainSectionHeading';
import InnerSection from 'ecosystem-marketplace-core/components/layout/InnerSection';
import ResultsGrid from '../storefront/results/ResultsGrid';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getLangCode } from '../../selectors/auth';

const MoreApps = ({
  category,
  fetchMoreApps,
  language,
  moreAppsHasCategoryResults,
  moreAppsRequestState,
  moreAppsResults,
  resetMoreApps,
  superCategory,
  slug,
  trackInteraction
}) => {
  const moreAppsQueries = useMemo(() => {
    return [new StorefrontFilters().merge({
      [FilterKey.CATEGORY]: category,
      [FilterKey.SORT_FIELD]: SortField.RANDOM
    }).toSearchQuery({
      length: 4,
      nextSearchMaxTrigger: 0
    }), new StorefrontFilters().merge({
      [FilterKey.SUPER_CATEGORY]: superCategory,
      [FilterKey.SORT_FIELD]: SortField.RANDOM
    }).toSearchQuery({
      length: 4
    })];
  }, [category, superCategory]);
  useEffect(() => {
    if (isUninitialized(moreAppsRequestState) && category && superCategory) {
      fetchMoreApps(language, moreAppsQueries, slug);
    }
  }, [category, fetchMoreApps, language, moreAppsRequestState, moreAppsQueries, slug, superCategory]);
  useEffect(() => {
    return () => resetMoreApps();
  }, [resetMoreApps]);
  return isSucceeded(moreAppsRequestState) && moreAppsResults.size && /*#__PURE__*/_jsx(MainSection, {
    color: "light",
    children: /*#__PURE__*/_jsxs(MainSectionInner, {
      children: [/*#__PURE__*/_jsx(MainSectionHeading, {
        itemRight: /*#__PURE__*/_jsx(UIRouterLink, {
          onClick: () => {
            trackInteraction('click more apps see all link', 'more apps');
          },
          to: moreAppsHasCategoryResults ? getCategoryFilterUrl(category, superCategory) : getSuperCategoryFilterUrl(superCategory),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "appMarketplace.detail.moreApps.seeAllLinkText"
          })
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.moreApps.headingText",
          options: {
            category: unescapedText(moreAppsHasCategoryResults ? getCategoryI18nKey(category) : getSuperCategoryI18nKey(superCategory))
          }
        })
      }), /*#__PURE__*/_jsx(InnerSection, {
        children: /*#__PURE__*/_jsx(ResultsGrid, {
          className: "vr-hidden",
          onResultClick: () => {
            trackInteraction('click more apps result item', 'more apps');
          },
          requestState: moreAppsRequestState,
          results: moreAppsResults,
          resultProps: {
            superCategory
          }
        })
      })]
    })
  });
};

MoreApps.propTypes = {
  category: PropTypes.string.isRequired,
  fetchMoreApps: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  resetMoreApps: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  superCategory: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  language: getLangCode(state),
  moreAppsResults: state.details.getIn(['moreApps', 'results']),
  moreAppsHasCategoryResults: state.details.getIn(['moreApps', 'hasCategoryResults']),
  moreAppsRequestState: state.requestStates[RequestKey.DETAILS_MORE_APPS_FETCH]
});

const mapDispatchToProps = {
  fetchMoreApps: DetailsActions.fetchMoreApps,
  resetMoreApps: DetailsActions.resetMoreApps
};
export default connect(mapStateToProps, mapDispatchToProps)(MoreApps);